module.exports = __webpack_public_path__ + "img/whatsapp-btn.719edc6.png";